module.exports = __webpack_public_path__ + "img/ganxi02.5833364b.png";